import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button
} from "@mui/material";
import  styles from "./DeviceModal.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

const DeviceModal = ({ device, open, onClose, onSave }) => {
  const [editedDevice, setEditedDevice] = useState(device);

  useEffect(() => {
    setEditedDevice(device);
  }, [open]);

  const handleChange = e => {
    const { name, value } = e.target;
    setEditedDevice(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    if (areRequiredFieldsFilled()) {
      onSave(editedDevice);
      onClose();
    }
  };

  const areRequiredFieldsFilled = () => {
    return (
      editedDevice.id?.trim() &&
      editedDevice.name?.trim() &&
      editedDevice.url?.trim() &&
      editedDevice.urlToken?.trim() &&
      editedDevice.userEmail?.trim() &&
      editedDevice.userPass?.trim()
    );
  };

  const isFieldInvalid = (fieldName) => {
    return !editedDevice[fieldName]?.trim();
  };

  return (
    <Dialog className={styles["dialog_device"]} open={open} onClose={onClose}>
      <DialogTitle>{i18n.t("edit.device")}</DialogTitle>
      <DialogContent>
        <TextField
          error={isFieldInvalid('id')}
          helperText={isFieldInvalid('id') ? i18n.t("required.field") : ''}
          margin="dense"
          label={i18n.t("id").toLowerCase()}
          type="text"
          fullWidth
          variant="outlined"
          name="id"
          value={editedDevice.id || ""}
          onChange={handleChange}
          required
        />
        <TextField
          margin="dense"
          label={i18n.t("ip").toLowerCase()}
          type="text"
          fullWidth
          variant="outlined"
          name="ip"
          value={editedDevice.ip || ""}
          onChange={handleChange}
        />
        <TextField
          error={isFieldInvalid('name')}
          helperText={isFieldInvalid('name') ? i18n.t("required.field") : ''}
          margin="dense"
          label={i18n.t("name")}
          type="text"
          fullWidth
          variant="outlined"
          name="name"
          value={editedDevice.name || ""}
          onChange={handleChange}
          required
        />
        <TextField
          margin="dense"
          label={i18n.t("port").toLowerCase()}
          type="text"
          fullWidth
          variant="outlined"
          name="port"
          value={editedDevice.port || ""}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          label={i18n.t("serial.number").toLowerCase()}
          type="text"
          fullWidth
          variant="outlined"
          name="serialReader"
          value={editedDevice.serialReader || ""}
          onChange={handleChange}
        />
        <TextField
          error={isFieldInvalid('url')}
          helperText={isFieldInvalid('url') ? i18n.t("required.field") : ''}
          margin="dense"
          label={i18n.t("url").toLowerCase()}
          type="text"
          fullWidth
          variant="outlined"
          name="url"
          value={editedDevice.url || ""}
          onChange={handleChange}
          required
        />
        <TextField
          error={isFieldInvalid('urlToken')}
          helperText={isFieldInvalid('urlToken') ? i18n.t("required.field") : ''}
          margin="dense"
          label={i18n.t("url.token").toLowerCase()}
          type="text"
          fullWidth
          variant="outlined"
          name="urlToken"
          value={editedDevice.urlToken || ""}
          onChange={handleChange}
          required
        />
        <TextField
          error={isFieldInvalid('userEmail')}
          helperText={isFieldInvalid('userEmail') ? i18n.t("required.field") : ''}
          margin="dense"
          label={i18n.t("email").toLowerCase()}
          type="text"
          fullWidth
          variant="outlined"
          name="userEmail"
          value={editedDevice.userEmail || ""}
          onChange={handleChange}
          required
        />
        <TextField
          error={isFieldInvalid('userPass')}
          helperText={isFieldInvalid('userPass') ? 'Este campo es requerido' : ''}
          margin="dense"
          label={i18n.t("password")}
          type="text"
          fullWidth
          variant="outlined"
          name="userPass"
          value={editedDevice.userPass || ""}
          onChange={handleChange}
          required
        />
      </DialogContent>
      <DialogActions>
        <Button className={styles["btn_cancel"]} onClick={onClose}>
        {capitalize(i18n.t("cancel"))}
        </Button>
        <Button
          className={styles["btn_save"]}
          onClick={handleSave}
          disabled={!areRequiredFieldsFilled()}
        >
          {capitalize(i18n.t("save"))}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeviceModal;
